import { render, staticRenderFns } from "./TeacherAttenBigScreen.vue?vue&type=template&id=1c9c1d3a&scoped=true"
import script from "./TeacherAttenBigScreen.vue?vue&type=script&lang=js"
export * from "./TeacherAttenBigScreen.vue?vue&type=script&lang=js"
import style0 from "./TeacherAttenBigScreen.vue?vue&type=style&index=0&id=1c9c1d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9c1d3a",
  null
  
)

export default component.exports